if (!customElements.get('collection-price-slider')) {
  customElements.define('collection-price-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const fields = [...this.querySelectorAll('price-range input')];
      const sliders = [...this.querySelectorAll('input[type="range"]')];
      const maximum = Number(this.dataset.maximum);
      if (fields.length !== 2 || !Number.isFinite(maximum) || maximum <= 0) return;
      sliders[0].value = this.initialized ? (fields[0].value || 0) : this.dataset.minimumValue;
      sliders[1].value = this.initialized ? (fields[1].value || maximum) : this.dataset.maximumValue;
      sliders[0].value = Math.min(+sliders[0].value, +sliders[1].value);
      this.initialized = true;
      // Native price-range expects unformatted numeric strings for its constraints.
      fields.forEach((field, i) => { if (field.value) field.value = sliders[i].value; });
      fields[0].dataset.max = sliders[1].value;
      fields[1].dataset.min = sliders[0].value;
      fields[1].dataset.max = maximum;
      this.querySelector('.collection-price-slider__ranges').hidden = false;
      sliders.forEach((slider, i) => {
        slider.addEventListener('input', (event) => {
          event.stopPropagation();
          slider.value = i === 0 ? Math.min(+slider.value, +sliders[1].value) : Math.max(+slider.value, +sliders[0].value);
          fields[i].value = slider.value;
          fields[0].dataset.max = sliders[1].value;
          fields[1].dataset.min = sliders[0].value;
        }, options);
        slider.addEventListener('change', (event) => {
          event.stopPropagation();
          fields[i].dispatchEvent(new Event('input', { bubbles: true }));
        }, options);
        fields[i].addEventListener('input', () => {
          const value = Number(fields[i].value);
          if (!Number.isFinite(value)) return;
          sliders[i].value = fields[i].value === '' ? (i === 0 ? 0 : maximum) : value;
        }, options);
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}
if (!customElements.get('collection-facet-drawer')) {
  customElements.define('collection-facet-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { capture: true, signal: this.abort.signal };
      const drawer = this.querySelector('menu-drawer');
      this.main = drawer.querySelector('details');
      this.summary = this.main.querySelector('summary');
      this.button = this.querySelector('.collection-facet-sticky');
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.mobile-facets__details > summary');
        if (this.dataset.mode !== 'accordion' || !summary) return;
        event.preventDefault(); event.stopImmediatePropagation();
        const details = summary.parentElement;
        details.open = !details.open;
        summary.setAttribute('aria-expanded', details.open);
      }, options);
      this.addEventListener('keyup', (event) => {
        const details = event.target.closest('.mobile-facets__details[open]');
        if (this.dataset.mode !== 'accordion' || event.code !== 'Escape' || !details) return;
        event.stopImmediatePropagation(); details.open = false;
        details.querySelector('summary').setAttribute('aria-expanded', false);
        details.querySelector('summary').focus();
      }, options);
      this.button.addEventListener('click', () => { this.fromSticky = true; if (!this.main.open) this.summary.click(); }, { signal: this.abort.signal });
      this.wasOpen = false;
      this.observer = new MutationObserver(() => {
        if (this.main.open && !this.wasOpen && this.dataset.mode === 'accordion') {
          this.querySelectorAll('.mobile-facets__details').forEach((details, i) => {
            details.open = this.dataset.openRows === 'all' || (this.dataset.openRows === 'first' && i === 0);
            details.querySelector('summary').setAttribute('aria-expanded', details.open);
          });
        }
        if (!this.main.open && this.wasOpen && this.fromSticky) {
          this.fromSticky = false;
          this.updateSticky();
          if (!this.button.hidden) this.button.focus();
        }
        this.wasOpen = this.main.open;
        this.updateSticky();
      });
      this.observer.observe(this.main, { attributes: true, attributeFilter: ['open'] });
      this.intersection = new IntersectionObserver((entries) => {
        this.pastTrigger = entries[0].boundingClientRect.bottom < 0;
        this.updateSticky();
      });
      this.intersection.observe(this.summary);
      const checkPosition = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.pastTrigger = this.summary.getBoundingClientRect().bottom < 0;
          this.updateSticky();
        });
      };
      window.addEventListener('scroll', checkPosition, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', checkPosition, { passive: true, signal: this.abort.signal });
      this.updateSticky();
    }
    updateSticky() { this.button.hidden = this.main.open || !(this.dataset.sticky === 'always' || (this.dataset.sticky === 'after_scrolling' && this.pastTrigger)); }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); this.intersection?.disconnect(); cancelAnimationFrame(this.frame); this.frame = null; }
  });
}
